import { Navigate, Outlet, useLocation } from "react-router-dom"

import AppLayout from "../../components/Layout"
import React from "react";
import { UserContext } from "../../contexts/AuthContext";
import { getProfileLocal } from "../common";

const PrivateRoutes = () => {

    const { profile } = React.useContext(UserContext);


    return (
        profile.is_panel ? <AppLayout><Outlet /></AppLayout> : <Navigate to="/login" />
    )
}

export default PrivateRoutes